import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space3XL, space4XL, spaceXL, spaceXXL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const ArticleSocialInteractionsContainer = styled.div`
  margin-bottom: ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${space3XL};
  }
`;

const CommentsContainer = styled.div`
  margin-top: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceXL};
  }
`;

const CommentsHeadline = styled(Headline)`
  margin-bottom: ${spaceXL};
`;

export const Styled = {
  ArticleSocialInteractionsContainer,
  CommentsContainer,
  CommentsHeadline,
};
